import * as React from 'react';

const CommentsContext = React.createContext({
  commentPanelStatus: false,
  setCommentPanelStatus: (value: boolean) => {},
  commPanelFormEnabled: true,
  setCommPanelFormEnabled: (value: boolean) => {},
  commPropId: '',
  setCommPropId: (value: string) => {},
  user: '',
  setUser: (value: string) => {},
  propsWithComments: [],
  isClientCommentEnabled: false,
  setPropsWithComments: (newPropsWithComments: string[]) => {},
  commentPending: false,
  setCommentPending: (value: boolean) => {},
  timeLeft: 0,
  setTimeLeft: (value: number) => {},
});

export default CommentsContext;
